/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { get } from "lodash";
import TextField from "components/text-field/text-field";
import { OneSignalConfig, Integrations } from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

interface Props {
  integration: { key: Integrations.OneSignal; value: OneSignalConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const OneSignal: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.api-key")}
        value={integration.value["api-key"]}
        onChange={(value) => updateIntegrationField(integrationName, { "api-key": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<OneSignalConfig>(errors)
            ? get(errors, ["errors", "value", "api-key", "0"])
            : undefined
        }
      />
      <TextField
        label={t("integrations.fields.app-id")}
        value={integration.value["app-id"]}
        onChange={(value) => updateIntegrationField(integrationName, { "app-id": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<OneSignalConfig>(errors) ? get(errors, ["errors", "value", "app-id", "0"]) : undefined
        }
      />
    </React.Fragment>
  );
};

export default OneSignal;
